import equal from 'fast-deep-equal';
import { create } from 'zustand';

import { GetUserProfile } from '../api';

type UserProfile = NonNullable<GetUserProfile['return']>;

type UseUserProfileStore = {
  initialValues: UserProfile | null;
  setProfile: (newProfile: UserProfile) => void;
  hasChanged: (newProfile: UserProfile) => boolean;
};

export const useUserProfileStore = create<UseUserProfileStore>((set, get) => ({
  initialValues: null,
  setProfile: (newProfile) => set({ initialValues: newProfile }),
  hasChanged: (newProfile) => !equal(get().initialValues, newProfile),
}));

export const useSelectedUserProfile = () =>
  useUserProfileStore((state) => state.initialValues);

export const setUserProfile = (newProfile: UserProfile) =>
  useUserProfileStore.getState().setProfile(newProfile);

export const hasUserProfileChanged = (newProfile: UserProfile) =>
  useUserProfileStore.getState().hasChanged(newProfile);
